import { createSlice } from "@reduxjs/toolkit";
import { GetUserServices, UpdateUserService } from "./thunk";

export const initialState = {
  user: {},
  
  error: "", // for error message
  loading: false,
  isAuthenticated:false, // for login
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.message;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
      // state.isAuthenticated = false

    },
    isPending(state, action) {
      state.loading = action.payload;
    },
    loginSuccess(state, action) {
      state.user = action.payload;

      state.loading = false;
      state.errorMsg = false;
      state.isAuthenticated = true
    },
    logoutUserSuccess(state) {
      state.isUserLogout = true
      state.isAuthenticated = false
    },
    chechAuth(state) {
      state.isAuthenticated = true
    },
    reset_login_flag(state) {
      state.error = null
      state.loading = false;
      state.errorMsg = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetUserServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetUserServices.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(GetUserServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Erreur inconnue';
      });
    builder
    .addCase(UpdateUserService.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(UpdateUserService.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload; // Met à jour les infos de l'utilisateur
    })
    .addCase(UpdateUserService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Erreur inconnue";
    });
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  chechAuth,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;